import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { PayeeCasesService } from '../payee-cases.service';
import { ChipDropdownComponent } from '../chip-dropdown/chip-dropdown.component';
import { PayeeFormFieldComponent } from '../../payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'payee-case-reference-id-filter',
  templateUrl: './case-reference-id-filter.component.html',
  styleUrls: ['./case-reference-id-filter.component.scss'],
  imports: [
    FormsModule,
    ChipDropdownComponent,
    PayeeFormFieldComponent,
    ReactiveFormsModule,
    PayeeButtonComponent,
    TranslateModule,
  ],
})
export class CaseReferenceIdFilterComponent implements OnInit, OnDestroy {
  private payeeCasesService = inject(PayeeCasesService);

  private readonly destroy = new Subject<void>();
  readonly caseIdControl = new FormControl<string | null>('', [
    Validators.required,
    Validators.minLength(3),
  ]);

  dropdownOpen = false;

  get selected() {
    return this.payeeCasesService.payee_case_reference_id.value;
  }

  ngOnInit(): void {
    this.payeeCasesService.payee_case_reference_id
      .pipe(takeUntil(this.destroy))
      .subscribe((v) => this.caseIdControl.patchValue(v));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  applyFilter(): void {
    if (this.caseIdControl.invalid) {
      this.caseIdControl.markAsDirty();
      return;
    }

    this.payeeCasesService.payee_case_reference_id.next(
      this.caseIdControl.value,
    );
    this.dropdownOpen = false;
  }

  clearFilter(): void {
    this.payeeCasesService.payee_case_reference_id.next(null);
    this.dropdownOpen = false;
  }

  displayWith(selected: string): string {
    return selected;
  }

  onPaste(_event: ClipboardEvent): void {
    this.caseIdControl.markAsTouched();
    setTimeout(() => {
      this.applyFilter();
    });
  }
}
